export const SET_CALENDAR = 'SET_CALENDAR';
export const SET_CURRENT_CALENDAR = 'SET_CURRENT_CALENDAR';
export const SET_ORDER_STATUS_CALENDAR = 'SET_ORDER_STATUS_CALENDAR';
export const UPDATE_CURRENT_CALENDAR = 'UPDATE_CURRENT_CALENDAR';
export const RESET_CALENDAR = 'RESET_CALENDAR';
